import { storyPageContent } from "../data/services";
import { motion } from "framer-motion";
import ServicesBanner from "../components/common/ServicesBanner";
import userImg from "../assets/icons/CLIENTImg.png";
import OpportunitiesImg from "../assets/icons/OPPORTUNITIESImg.png";
import ChallengesImg from "../assets/icons/CHALLENEGS.jpg";
import SuccessImg from "../assets/icons/SUCCESS.jpg";
const SuccessStory4 = () => {
  // const story = getSuccessStoryById(2);

  const {bannerTitle, bannerImage } =
    storyPageContent;
  const cardVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: { delay: i * 0.2, duration: 0.5 },
    }),
  };
  const cards = [
    {
      title: "クライアントの背景",
      img: userImg,
      description:
        "当社のクライアントは自動車金融部門で事業を展開しており、顧客に自動車ローンへのシームレスなアクセスを提供しています。 \n 特に、同社は、ユーザーが自動車を閲覧したり、ローンの支払いを計算したり、ローンに関する問い合わせを送信したりできるウェブベースのプラットフォームを提供しています。 \n さらに、このプラットフォームはサードパーティのアプリケーションと連携して、見込み顧客を獲得したり、顧客とのやり取りを効率的に管理することができます。",
    },
    {
      title: "機会",
      img: OpportunitiesImg,
      description:
        "• クライアントは、顧客エンゲージメントを改善し、ローン問い合わせ管理を効率化することで、デジタルプレゼンスを強化したいと考えていました。\n• 改善が必要とされた主領域には、よりインタラクティブな使用感を実現する顧客向けWebアプリケーションの開発も含まれていました。\n• また、複数のソースを通じた顧客からの問い合わせを管理するための堅牢な管理パネルを構築すること、\n• 外部API と統合して、包括的な車のリストと即時の見積もりを提供すること、そして \n• 顧客が十分な情報に基づいて財務上の決定を下せるよう、ユーザーフレンドリーなローン計算ツールを実装することも要件に含まれていました。",
    },
    {
      title: "課題",
      img: ChallengesImg,
      description:
        "• 錯綜した見込み顧客管理：一元化されておらず、追跡とフォローアップが非効率的 \n• UI/UXの強化：直感的なナビゲーションとシームレスなインタラクションが必要  \n• 外部サイトとの統合：正確なデータを得るために、CarAPIおよびMyNewCarとのスムーズなAPI統合が必要 \n• 自動見積：手動ローン見積機能のため、即時にPDF出力ができるよう自動化が必要 \n• 使いやすいローン計算：ユーザーが月々の支払額を簡単に見積もる方法が必要 ",
    },
    {
      title: "解決策と成功",
      img: SuccessImg,
      description:
        "• 顧客向けWebアプリ：場所の自動検出機能を備えた応答性の高いプラットフォームを構築しました。\n• 管理パネル: お問い合わせを追跡および管理するためのシステムを開発しました。 \n• API統合：一覧化についてはCarAPIに接続し、各車種の仕様についてはMyNewCarに接続します。\n• 自動見積：顧客の詳細からPDFをすぐにその場で生成できるようになりました。   ",
    },
  ];
  return (
    <div className="bg-gradient-to-b from-white to-gray-100 mb-5 mx-auto">
      {/* Banner Section */}
      <ServicesBanner title={bannerTitle} heroImage={bannerImage} />
      <div className="max-w-5xl mx-auto md:px-10 lg:px-10 lg:max-w-fit">
        <div className="flex justify-center items-center">
          {/* Header Section */}
          <div className="m-5">
            <h1 className="text-3xl font-bold mt-2">
            <span>スマートカーローンプラットフォーム</span>
            </h1>
          </div>
        </div>
        <div className="grid md:grid-cols-2 sm:grid-cols-1 gap-x-10 gap-y-10 w-full max-w-6xl mx-auto">
          {cards.map((card, i) => (
            <motion.div
              key={card.title}
              custom={i}
              initial="hidden"
              animate="visible"
              variants={cardVariants}
              className="bg-white rounded-2xl shadow-md hover:shadow-xl hover:shadow-blue-100 p-10 transition duration-300 ease-in-out"
            >
              <div className="flex items-center gap-4 mb-4">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-16 h-16 rounded-full border border-gray-200"
                />
                <h3 className="text-2xl font-semibold text-blue-700">
                  {card.title}
                </h3>
              </div>
              <p className="text-gray-800 leading-relaxed text-lg">
                {card.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SuccessStory4;
